import {useTranslation} from 'react-i18next';
import {Sparkles} from 'lucide-react';
import {useTheme} from 'styled-components';
import {useReservation} from 'context/reservation';
import {usePaymentSettings, useFetchOffers} from 'hooks';
import {formatPrice} from '../price';
import {
  Container,
  List,
  StyledOfferCard,
  HeaderContainer,
  HederText,
  Title,
  Description,
} from './styled';

export const HomeUpsellingList = () => {
  const {t} = useTranslation();
  const {hasTemplate} = useTheme();
  const {data: reservation} = useReservation();
  const {data: paginatedOfferList, isLoading} = useFetchOffers({
    housingId: reservation?.housing_id,
  });
  const {currencySymbol} = usePaymentSettings();

  if (paginatedOfferList?.count === 0 || isLoading) {
    return null;
  }

  return (
    <Container>
      <HeaderContainer>
        <div className="w-10 h-10 rounded-full flex items-center justify-center [background-color:var(--background-secondary)]">
          <Sparkles
            size={20}
            color={hasTemplate ? 'var(--brand-icons)' : 'var(--font-secondary)'}
          />
        </div>

        <HederText>
          <Title>{t('home_upselling_list.title')}</Title>
          <Description>{t('home_upselling_list.description')}</Description>
        </HederText>
      </HeaderContainer>
      <List>
        {paginatedOfferList?.results.map(
          ({title, id, price_type, items, highlight, image_url}) => (
            <StyledOfferCard
              key={id}
              id={id}
              title={title}
              price={formatPrice(currencySymbol)({priceType: price_type, items})}
              imageUrl={image_url}
              highlight={highlight}
            />
          ),
        )}
      </List>
    </Container>
  );
};
